import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-mail-heart-icon',
  templateUrl: './communication-mail-heart.component.html'
})
export class CommunicationMailHeartComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
